"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var ThumbsUp = function ThumbsUp(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2.default)({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), (0, _core.jsx)("path", {
    d: "M5.752 11.382h1.26c.388 0 .754-.18.99-.488l2.492-3.238a1.25 1.25 0 00.26-.762V4.507a.616.616 0 01.625-.625c.802 0 1.875.937 1.875 2.812a8.356 8.356 0 01-.514 3.212.158.158 0 00.14.225h4.074a1.285 1.285 0 011.287 1.06c.08.521-.178 1.036-.642 1.284a1.241 1.241 0 01-.179 2.268c.228.16.394.393.471.66.081.303.045.624-.1.901a1.125 1.125 0 01-.97.684c.135.217.198.471.181.726a1.302 1.302 0 01-1.321 1.168h-4.664a5.002 5.002 0 01-2.774-.84l-.3-.2a1.25 1.25 0 00-.694-.21H5.752a.625.625 0 01-.625-.625v-5a.625.625 0 01.625-.625z",
    fill: "currentColor"
  }));
};

var _default = (0, _react.forwardRef)(ThumbsUp);

var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(ThumbsUp, "ThumbsUp", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/ThumbsUp.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/ThumbsUp.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9JY29ucy9UaHVtYnNVcC50c3giXSwibmFtZXMiOlsiVGh1bWJzVXAiLCJwcm9wcyIsInJlZiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7OztBQUFBOzs7Ozs7Ozs7Ozs7O0FBRUEsSUFBTUEsUUFBd0UsR0FBRyxTQUEzRUEsUUFBMkUsQ0FBQ0MsS0FBRCxFQUFRQyxHQUFSO0FBQUEsU0FDL0U7QUFBSyxJQUFBLEtBQUssRUFBRSxFQUFaO0FBQWdCLElBQUEsTUFBTSxFQUFFLEVBQXhCO0FBQTRCLElBQUEsT0FBTyxFQUFDO0FBQXBDLEtBQW9ERCxLQUFwRDtBQUEyRCxJQUFBLEdBQUcsRUFBRUM7QUFBaEUsTUFDRTtBQUNFLElBQUEsQ0FBQyxFQUFDLDJnQkFESjtBQUVFLElBQUEsSUFBSSxFQUFDO0FBRlAsSUFERixDQUQrRTtBQUFBLENBQWpGOztlQVNlLHVCQUFXRixRQUFYLEM7Ozs7Ozs7Ozs7Ozs7MEJBVFRBLFEiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QsIHsgZm9yd2FyZFJlZiwgUmVmRm9yd2FyZGluZ0NvbXBvbmVudCwgU1ZHUHJvcHMgfSBmcm9tICdyZWFjdCc7XG5cbmNvbnN0IFRodW1ic1VwOiBSZWZGb3J3YXJkaW5nQ29tcG9uZW50PFNWR1NWR0VsZW1lbnQsIFNWR1Byb3BzPFNWR1NWR0VsZW1lbnQ+PiA9IChwcm9wcywgcmVmKSA9PiAoXG4gIDxzdmcgd2lkdGg9ezI0fSBoZWlnaHQ9ezI0fSB2aWV3Qm94PVwiMCAwIDI0IDI0XCIgey4uLnByb3BzfSByZWY9e3JlZn0+XG4gICAgPHBhdGhcbiAgICAgIGQ9XCJNNS43NTIgMTEuMzgyaDEuMjZjLjM4OCAwIC43NTQtLjE4Ljk5LS40ODhsMi40OTItMy4yMzhhMS4yNSAxLjI1IDAgMDAuMjYtLjc2MlY0LjUwN2EuNjE2LjYxNiAwIDAxLjYyNS0uNjI1Yy44MDIgMCAxLjg3NS45MzcgMS44NzUgMi44MTJhOC4zNTYgOC4zNTYgMCAwMS0uNTE0IDMuMjEyLjE1OC4xNTggMCAwMC4xNC4yMjVoNC4wNzRhMS4yODUgMS4yODUgMCAwMTEuMjg3IDEuMDZjLjA4LjUyMS0uMTc4IDEuMDM2LS42NDIgMS4yODRhMS4yNDEgMS4yNDEgMCAwMS0uMTc5IDIuMjY4Yy4yMjguMTYuMzk0LjM5My40NzEuNjYuMDgxLjMwMy4wNDUuNjI0LS4xLjkwMWExLjEyNSAxLjEyNSAwIDAxLS45Ny42ODRjLjEzNS4yMTcuMTk4LjQ3MS4xODEuNzI2YTEuMzAyIDEuMzAyIDAgMDEtMS4zMjEgMS4xNjhoLTQuNjY0YTUuMDAyIDUuMDAyIDAgMDEtMi43NzQtLjg0bC0uMy0uMmExLjI1IDEuMjUgMCAwMC0uNjk0LS4yMUg1Ljc1MmEuNjI1LjYyNSAwIDAxLS42MjUtLjYyNXYtNWEuNjI1LjYyNSAwIDAxLjYyNS0uNjI1elwiXG4gICAgICBmaWxsPVwiY3VycmVudENvbG9yXCJcbiAgICAvPlxuICA8L3N2Zz5cbik7XG5cbmV4cG9ydCBkZWZhdWx0IGZvcndhcmRSZWYoVGh1bWJzVXApO1xuIl19